"use strict";

const EXAMPLES = [
  {
    id: "starter",
    label: "Kitchen sink",
    description: "A realistic template with spacing and trailing whitespace to fix, plus indentation to edit manually.",
    preset: "recommended",
    fileName: "profile-card.hbs",
    expectedRule: "mustache-spacing",
    source: [
      '<article class="profile-card">',
      "{{#if user}}",
      "    <h2>{{ user.name}}</h2>  ",
      "    {{>avatar user }}",
      "{{/if}}",
      "</article>",
      "",
    ].join("\n"),
  },
  {
    id: "empty-config",
    label: "Empty configuration",
    description: "Start with no enabled rules and add them one at a time.",
    preset: "empty",
    fileName: "empty-config.hbs",
    expectedRule: null,
    source: [
      "{{#if user}}",
      "    <h2>{{ user.name}}</h2>  ",
      "    {{>avatar user }}",
      "{{/if}}",
      "",
    ].join("\n"),
  },
  {
    id: "mustache-spacing",
    label: "Mustache spacing",
    description: "Fix asymmetric padding while keeping already-valid spacing unchanged.",
    preset: "recommended",
    fileName: "spacing.hbs",
    expectedRule: "mustache-spacing",
    source: "<h1>{{ title}}</h1>\n<p>{{description }}</p>\n",
  },
  {
    id: "indentation",
    label: "Block indentation",
    description: "Nested content should follow Handlebars block depth.",
    preset: "recommended",
    fileName: "navigation.hbs",
    expectedRule: "indentation",
    source: "{{#if navigation}}\n    <nav>{{navigation}}</nav>\n{{/if}}\n",
  },
  {
    id: "partial-spacing",
    label: "Partial spacing",
    description: "Add the required separator after the greater-than marker with an automatic fix.",
    preset: "recommended",
    fileName: "partials.hbs",
    expectedRule: "partial-spacing",
    source: "{{>header}}\n<main>{{>content}}</main>\n{{>footer}}\n",
  },
  {
    id: "trailing-spaces",
    label: "Trailing spaces",
    description: "Invisible spaces at the ends of lines are still diagnostics.",
    preset: "recommended",
    fileName: "whitespace.hbs",
    expectedRule: "no-trailing-spaces",
    source: "<section>   \n  {{content}}\t\n</section>\n",
  },
  {
    id: "final-newline",
    label: "Final newline",
    description: "Templates should end with a newline.",
    preset: "recommended",
    fileName: "footer.hbs",
    expectedRule: "eol-last",
    source: "<footer>{{copyright}}</footer>",
  },
  {
    id: "linebreak-style",
    label: "Linebreak style",
    description: "The recommended preset expects Unix line endings.",
    preset: "recommended",
    fileName: "windows-linebreaks.hbs",
    expectedRule: "linebreak-style",
    source: "<header>\r\n  {{title}}\r\n</header>\r\n",
  },
  {
    id: "invalid-bracket-path",
    label: "Invalid bracket path",
    description: "Legacy bracket paths are reported at a stable location.",
    preset: "recommended",
    fileName: "paths.hbs",
    expectedRule: "no-invalid-bracket-path",
    source: "{{#with user[name]}}\n  {{name}}\n{{/with}}\n",
  },
  {
    id: "parse-error",
    label: "Parse error",
    description: "Malformed Handlebars produces a parser diagnostic.",
    preset: "recommended",
    fileName: "broken-template.hbs",
    expectedRule: "parse-error",
    source: "{{#if user}}\n  <p>{{user.name}}</p>\n",
  },
  {
    id: "custom-config",
    label: "Custom rule override",
    description: "An extended configuration catches built-in block helpers used inline.",
    preset: "custom",
    fileName: "custom-config.hbs",
    expectedRule: "no-bare-builtin-block-helpers",
    source: '{{if isAdmin "Admin" "Member"}}\n',
  },
];

module.exports = {
  EXAMPLES,
};
